<template>
	<div class="section">
		<div class="profile_page">
			<h2 class="success info_header">Пользователь создан</h2>
			<h4>Мы отправили вам письмо для активации</h4>
			<h4>Пожалуйста проверьте почту</h4>
			<h4 class="mb-0">Если письмо вам не пришло, свяжитесь с администратором</h4>
		</div>
	</div>
</template>

<script>
export default {
	name: 'RegisterSuccess'
}
</script>

<style scoped>
.profile_page {
	max-width: 1000px;
	text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/views/Register/Success.vue